/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Land_Title_Showcase_ForestInputs */

const en_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Forest`)
};

const ar_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · الغابة`)
};

const de_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Wald`)
};

const es_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Bosque`)
};

const fr_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Forêt`)
};

const it_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Foresta`)
};

const ja_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · マイフォレスト`)
};

const ko_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 나의 숲`)
};

const pt_br_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Floresta`)
};

const ru_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Лес`)
};

const th_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · ป่า`)
};

const tr_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Orman`)
};

const zh_cn_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 森林`)
};

const zh_tw_shop_land_title_showcase_forest = /** @type {(inputs: Shop_Land_Title_Showcase_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 森林`)
};

/**
* | output |
* | --- |
* | "· Forest" |
*
* @param {Shop_Land_Title_Showcase_ForestInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const shop_land_title_showcase_forest = /** @type {((inputs?: Shop_Land_Title_Showcase_ForestInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Land_Title_Showcase_ForestInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shop_land_title_showcase_forest(inputs)
	if (locale === "ar") return ar_shop_land_title_showcase_forest(inputs)
	if (locale === "de") return de_shop_land_title_showcase_forest(inputs)
	if (locale === "es") return es_shop_land_title_showcase_forest(inputs)
	if (locale === "fr") return fr_shop_land_title_showcase_forest(inputs)
	if (locale === "it") return it_shop_land_title_showcase_forest(inputs)
	if (locale === "ja") return ja_shop_land_title_showcase_forest(inputs)
	if (locale === "ko") return ko_shop_land_title_showcase_forest(inputs)
	if (locale === "pt_br") return pt_br_shop_land_title_showcase_forest(inputs)
	if (locale === "ru") return ru_shop_land_title_showcase_forest(inputs)
	if (locale === "th") return th_shop_land_title_showcase_forest(inputs)
	if (locale === "tr") return tr_shop_land_title_showcase_forest(inputs)
	if (locale === "zh_cn") return zh_cn_shop_land_title_showcase_forest(inputs)
	return zh_tw_shop_land_title_showcase_forest(inputs)
});